import { useEffect, useState } from "react";
import { getFilesByPetId } from "../../api/uploadService";

export const usePetFiles = (
  id,
  {
    page = 1,
    limit = 10,
    tags = "",
    mode = "",
    sort = "",
    order = "",
    trigger
  } = {}
) => {
  const [petFiles, setPetFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getFilesByPetId(id, page, limit, tags, mode, sort, order)
      .then(setPetFiles)
      .finally(() => setLoading(false));
  }, [id, page, limit, tags, mode, sort, order, trigger]);

  return { petFiles, loading, setPetFiles };
};
